import { useTheme } from "@emotion/react";
import { CelulaLinhaTabela } from "../CelulaLinhaTabela";
import * as S from "./styles";
import { useState } from "react";

export function LinhaTabela({ dados, itensTabela }) {
  const theme = useTheme();

  const [expandidos, setExpandidos] = useState({});

  const toggle = (id) => {
    setExpandidos((old) => ({
      ...old,
      [id]: !old[id],
    }));
  };

  const LinhaRecursiva = ({ obj, dados, nivel, expandidos, toggle }) => {
    return (
      <>
        <S.StyledTr
          dados={dados}
          onClick={() => obj.possuiFilhos && toggle(obj.id)}
          style={{
            cursor: obj.possuiFilhos ? "pointer" : "default",
          }}
        >
          {dados.colunasTabelaSecundaria?.map((coluna, colunaIndex) => (
            <CelulaLinhaTabela
              key={`${obj.id}-${coluna.key}`}
              item={
                colunaIndex === 0 ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: `${nivel * 24}px`,
                    }}
                  >
                    {obj.possuiFilhos && (
                      <span
                        onClick={(e) => {
                          e.stopPropagation();
                          toggle(obj.id);
                        }}
                        style={{
                          cursor: "pointer",
                          marginRight: 8,
                          fontWeight: "bold",
                        }}
                      >
                        {expandidos[obj.id] ? (
                          <S.StyledMinus weight="bold" />
                        ) : (
                          <S.StyledPlus weight="bold" />
                        )}
                      </span>
                    )}

                    {obj[coluna.key]}
                  </div>
                ) : (
                  obj[coluna.key]
                )
              }
              coluna={coluna}
            />
          ))}
        </S.StyledTr>

        {expandidos[obj.id] &&
          obj.itensTabelaSecundaria?.map((filho) => (
            <LinhaRecursiva
              key={filho.id}
              obj={filho}
              dados={dados}
              nivel={nivel + 1}
              expandidos={expandidos}
              toggle={toggle}
            />
          ))}
      </>
    );
  };

  return (
    <>
      {itensTabela.itensTabelaSecundaria?.map((obj) => (
        <LinhaRecursiva
          key={obj.id}
          obj={obj}
          dados={dados}
          nivel={0}
          expandidos={expandidos}
          toggle={toggle}
        />
      ))}
    </>
  );
}
